/**************************************************
 * Nombre:       TarjetaTestimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Rating, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const TarjetaTestimonios = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: -4}}>
                <Avatar src={item.foto} sx={{border: 2, width: 100, height: 100}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    border: 4,
                    borderRadius: 12,
                    px: sCell ? 4 : 8,
                    py: 6,
                    mx: 2,
                    mb: 7
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600, textAlign: 'center', fontSize: 18}}>
                        {item.descripcion}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Rating size={'large'} value={5}/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default TarjetaTestimonios    